import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  targetConnectionsHeading: {
    id: 'YyGWfF',
    defaultMessage: 'Target Connections: {count}',
    description: 'Heading above the table listing the connections this product can sync to',
  },
  syncNowButton: {
    id: 'P5i35N',
    defaultMessage: 'Sync Now',
    description: 'Button that queues a stock sync for this product',
  },
  columnConnectionName: {
    id: '3cKG1K',
    defaultMessage: 'Connection',
    description: 'Column header for the selling channel name',
  },
  columnStatus: {
    id: '5MSOW2',
    defaultMessage: 'Status',
    description: 'Column header for the connection sync status',
  },
  columnLastSynced: {
    id: '04AID/',
    defaultMessage: 'Last Sync',
    description: 'Column header for the quantity the connection last received and when it received it',
  },
  columnNextSync: {
    id: 'TQr7Li',
    defaultMessage: 'Next Sync',
    description: 'Column header for the quantity that will be sent to the connection on its next sync',
  },
  columnConfig: {
    id: 'pS1BlZ',
    defaultMessage: 'Config',
    description: 'Column header for the summary of the sync rules applied to the connection',
  },
  columnActions: {
    id: 'gAI9JK',
    defaultMessage: 'Actions',
    description: 'Column header for the per-row actions menu',
  },
  nextSyncTooltip: {
    id: 'RcST5n',
    defaultMessage: 'This is the number that will sync on the next job',
    description: 'Tooltip explaining the Next Sync column',
  },
  lastSyncedQtyTooltip: {
    id: 'qADwa1',
    defaultMessage: 'The quantity this channel received on its most recent sync job.',
    description: 'Tooltip explaining the scope of the Last Synced Qty column',
  },
  statusActive: {
    id: 'S+r0o9',
    defaultMessage: 'Active',
    description: 'Status pill for a connection that is actively syncing',
  },
  statusInactive: {
    id: 'PAd+nf',
    defaultMessage: 'Inactive',
    description: 'Status pill for a connection that is not syncing',
  },
  statusSyncing: {
    id: 'xX6aRk',
    defaultMessage: 'Syncing',
    description: 'Status pill for a connection that is currently running a sync job',
  },
  statusSyncFailed: {
    id: '1SaSPS',
    defaultMessage: 'Sync failed',
    description: 'Status pill for a connection whose most recent sync job failed',
  },
  neverSynced: {
    id: 'i6fuzI',
    defaultMessage: 'Never',
    description: 'Shown in the Last Synced column when a connection has never synced',
  },
  notATargetTooltip: {
    id: 'Y6lk6v',
    defaultMessage: 'You cannot sync to this channel because it is not selected as a target in your inventory sync settings.',
    description: 'Tooltip on the info icon for a connection that is not selected as a sync target',
  },
  targetUnsupportedTooltip: {
    id: 'uhEoZe',
    defaultMessage: 'This channel cannot receive stock counts from ShipStation, so it cannot be used as a sync target.',
    description: 'Tooltip on the info icon for a connection whose integration cannot be a sync target at all',
  },
  perProductSyncUnavailable: {
    id: 'KqEwyM',
    defaultMessage: 'Syncing a single product is not available yet. Run a manual sync from your inventory sync settings instead.',
    description: 'Tooltip explaining why the Sync Now button is disabled',
  },
  configSummaryMinimum: {
    id: 'dzBH5f',
    defaultMessage: 'Min: {quantity}',
    description: 'Part of the config summary describing the minimum quantity rule',
  },
  configSummaryMaximum: {
    id: '38y1un',
    defaultMessage: 'Max: {quantity}',
    description: 'Part of the config summary describing the maximum quantity rule',
  },
  configSummaryBuffer: {
    id: 'gQkh0H',
    defaultMessage: 'Buffer: {quantity}',
    description: 'Part of the config summary describing the buffer stock rule',
  },
  configSummaryPercentage: {
    id: '5h/sQr',
    defaultMessage: '{percentage}% of stock',
    description: 'Part of the config summary describing the percentage of stock rule',
  },
  configSummaryNoRules: {
    id: 'zB+rOD',
    defaultMessage: 'No rules set',
    description: 'Config summary shown when a connection has no quantity rules configured',
  },
  configScopeConnection: {
    id: 'z+0LsW',
    defaultMessage: 'Channel default',
    description: 'Caption clarifying that the config summary is the connection-level default, not a per-product value',
  },
});
